module.exports = __webpack_public_path__ + "img/P150T_weapon_45.29099e7a.png";